'use client'

import { useState, useEffect } from 'react'
import { AnimatePresence, motion } from 'motion/react'
import Loader from 'app/components/host-site/components/Loader'
import SkeletonLoader from 'app/components/host-site/components/Skeleton'
import Navbar from 'app/components/host-site/components/Navbar'
import Hero from 'app/components/host-site/components/Hero'
import TrustedBy from 'app/components/host-site/components/TrustedBy'
import Features from 'app/components/host-site/components/Features'
import Dashboard from 'app/components/host-site/components/Dashboard'
import Performance from 'app/components/host-site/components/Performance'
import Partners from 'app/components/host-site/components/Partners'
import CTA from 'app/components/host-site/components/CTA'
import Footer from 'app/components/host-site/components/Footer'

/** Host-only marketing home (formerly `app/test/page.tsx`). */
export default function HostMarketingHome() {
    const [loadingState, setLoadingState] = useState<'loader' | 'skeleton' | 'content'>('loader')

    useEffect(() => {
        const loaderTimer = setTimeout(() => {
            setLoadingState('skeleton')
        }, 2000)

        const skeletonTimer = setTimeout(() => {
            setLoadingState('content')
        }, 4000)

        return () => {
            clearTimeout(loaderTimer)
            clearTimeout(skeletonTimer)
        }
    }, [])

    return (
        <main className='min-h-screen overflow-x-hidden bg-[#0a0a0a] font-sans text-white selection:bg-[#b4ff00] selection:text-black'>
            <AnimatePresence mode='wait'>
                {loadingState === 'loader' && (
                    <motion.div key='loader' exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
                        <Loader />
                    </motion.div>
                )}

                {loadingState === 'skeleton' && (
                    <motion.div
                        key='skeleton'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <Navbar />
                        <SkeletonLoader />
                    </motion.div>
                )}

                {loadingState === 'content' && (
                    <motion.div
                        key='content'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8 }}
                    >
                        <Navbar />
                        <Hero />
                        <TrustedBy />
                        <Features />
                        <Dashboard />
                        <Performance />
                        <Partners />
                        <CTA />
                        <Footer />
                    </motion.div>
                )}
            </AnimatePresence>
        </main>
    )
}
